exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".logo-juego-footer {\n  width: 200px; }\n\n.textColor {\n  color: white;\n  display: block; }\n\n.icon-footer {\n  width: 90px; }\n\n.icon-footer-left {\n  margin-left: 17px; }\n\n.margin-left {\n  margin-left: -3rem; }\n\n.margin-top-footer-img {\n  margin-top: -1rem; }\n\n.background-transparent {\n  background: transparent; }\n\n.footer-title {\n  color: white;\n  font-weight: 900; }\n\n.icon-footer-movil {\n  width: 90%;\n  margin-bottom: -2rem; }\n\n.pointer {\n  cursor: pointer; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/src/app/layouts/shared/footer/footer.scss
// module id = ../../../../../src/app/layouts/shared/footer/footer.scss
// module chunks = 6